import debounce from 'debounce';

import { UrlAdaptor } from '@syncfusion/ej2-data';

import { routes } from '@/shared/routes';

// Patch UrlAdaptor to set Accept header to application/json (not */*)
UrlAdaptor.prototype.beforeSend = (_dm, request) => {
  request.headers.set('Accept', 'application/json');
};

// Patch XMLHttpRequest to redirect error statuses to appropriate page
// @ts-ignore
XMLHttpRequest.prototype.send_ = XMLHttpRequest.prototype.send;
XMLHttpRequest.prototype.send = function (body) {
  this.addEventListener(
    'readystatechange',
    debounce(() => {
      if (!this.responseURL.startsWith('https://beaconapi.helpscout.net')) {
        if (this.status >= 400) {
          if (this.status === 401 || this.status === 403) {
            window.location.href = routes.unauthorised;
          } else if (this.status === 404) {
            window.location.href = routes.notFound;
          } else {
            console.error(this.statusText);
            window.location.href = routes.error;
          }
        }
      }
    }),
  );
  // @ts-ignore
  this.send_(body);
};
